import { memo, useCallback } from 'react';
import PlayerTimelineButton from './PlayerTimelineButton';
import { IconName } from '@/components/atoms/Icon';
import {
  PlayRateValue,
  useRemotionPlayerRate
} from '@/App/remotion/MainPlayer/ClipPlayerV2WithNewTimeline/hooks/useRemotionPlayerRate';

type PlayRate = {
  value: PlayRateValue;
  icon: IconName;
};

const PLAY_RATES: PlayRate[] = [
  { value: PlayRateValue.HALF, icon: 'IconMultiplier05x' },
  { value: PlayRateValue.NORMAL, icon: 'IconMultiplier1x' },
  { value: PlayRateValue.ONE_POINT_FIVE, icon: 'IconMultiplier15x' },
  { value: PlayRateValue.DOUBLE, icon: 'IconMultiplier2x' }
];

const PlaybackRate = () => {
  const { rate, setRate } = useRemotionPlayerRate();

  const handlePlayRateMultiplierClick = useCallback(() => {
    const currentIndex = PLAY_RATES.findIndex(playRate => playRate.value === rate);
    const nextIndex = (currentIndex + 1) % PLAY_RATES.length;
    setRate(PLAY_RATES[nextIndex].value);
  }, [rate, setRate]);

  const iconName = PLAY_RATES.find(item => item.value === rate)?.icon || 'IconMultiplier1x';

  return (
    <PlayerTimelineButton
      tooltipTitle="Adjust playback speed"
      buttonId="play-rate-multiplier-button"
      onClick={handlePlayRateMultiplierClick}
      iconName={iconName}
    />
  );
};

export default memo(PlaybackRate);
